import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center m-5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex flex-wrap items-center justify-center m-auto overflow-y-auto mt-4 max-h-[560px]" }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SportSelector = _resolveComponent("SportSelector")!
  const _component_ActivityAvailability = _resolveComponent("ActivityAvailability")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.onlyOneSport())
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("sport")), 1),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SportSelector, {
              modelValue: _ctx.activeSport,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSport) = $event)),
              sports: _ctx.tenantInfo.tenant.sports,
              showLabels: false,
              titleTop: false,
              onSportSelected: _ctx.setActiveSport
            }, null, 8, ["modelValue", "sports", "onSportSelected"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.errorMsg)
        ? (_openBlock(), _createBlock(_component_ActivityAvailability, {
            key: 0,
            activities: _ctx.activitiesDataSource
          }, null, 8, ["activities"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1))
    ])
  ]))
}